const INITIAL_STATE = {
  tryRedirect: false,
  showFilters: true
};

const SearchOtsMeetData = {
  INITIAL_STATE
}

export default SearchOtsMeetData;